module.exports = __webpack_public_path__ + "05_long_black.0384ca90.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/05_long_black.png
// module id = QqFA
// module chunks = 0